import { get, post, del, put, post2, putJson, postFile, getFileDown, getFile2, getFile } from './http.js'


// 菜单相关接口
export const menuListApi = g => get('/api/menu/v1/menus', g);//获取菜单列表（有子菜单形式）
export const menusApi = g => get('/api/menu/v1/menus/list', g);//获取菜单列表
export const menuAddApi = g => post2(`/api/menu/v1/menus`, g);//新增菜单
export const getOneMenuApi = (id,p) => get(`/api/menu/v1/menus/${id}` , p) //获取单个菜单
export const menuPutApi = (id, p) => putJson(`/api/menu/v1/menus/${id}`, p);//修改菜单
export const menuDelApi = (id,p) => del(`/api/menu/v1/menus/${id}`,p)//删除菜单

//后台角色相关的服务
export const roleInitApi = p => post(`/api/role/v1/addRolePrivilege`, p);//更新或新增用户角色
export const roleGetApi = p => get(`/api/role/v1/getPrivileageList`, p);//获取有checkbox的菜单权限树
export const rolesApi = p => get(`/api/role/v1/roles`, p);//获取角色列表
export const roleAddApi = p => post2(`/api/role/v1/roles`, p);//新增角色
export const roleOneApi = (id,p) => get(`/api/role/v1/roles/${id}`, p);//获取单个角色
export const rolePutApi = p => putJson(`/api/role/v1/roles`, p);//修改角色
export const roleDelApi = id => del(`/api/role/v1/roles/${id}`);//删除角色

//后台用户相关菜单
export const captchaCode = p => get(`/api/user/v1/validate`,p);//获取图形验证码
export const loginApi = p => post2(`/api/user/v1/login`, p);//登录
export const userInfo = p => get(`/api/my/profile/v1/info`);//获取用户信息
export const loginoutApi = p => post(`/api/user/v1/logout`, p);//登出 
export const userMenusApi = p => get(`/api/user/v1/menus`, p);//获取用户菜单和权限
export const userListApi = g => get(`/api/user/v1/users`, g);//获取用户列表
export const userAddApi = p => post2(`/api/user/v1/users`, p);//新增用户
export const userOneApi = (id,p) => get(`/api/user/v1/users/${id}`, p);//用户详情
export const userPutApi = p => putJson(`/api/user/v1/users`, p);//修改用户
export const userDelApi = (id, p) => del(`/api/user/v1/users/${id}`, p);//删除用户
export const resetPwdApi = (id,p) => put(`/api/user/v1/users/${id}/password/reset`,p)//重置用户密码

//部门相关服务
export const officeListApi = p => get(`/api/office/v1/offices/list`,p); //获取部门列表，列表结构
export const officeTreeApi = p => get(`/api/office/v1/offices`,p); //获取部门列表，列表结构
export const officeAddApi = p => post2(`/api/office/v1/offices`,p); //新增部门
export const officeOneApi = (id,p) => get(`/api/office/v1/offices/${id}`,p); //部门详情
export const officePutApi = (id,p) => putJson(`/api/office/v1/offices/${id}`,p); //修改部门
export const officeDelApi = (id,p) => del(`/api/office/v1/offices/${id}`,p); //删除部门

//字典相关接口
export const dictDelApi = (id,p) => del(`/api/dict/v1/dicts/${id}`,p);//删除字典
export const dictPutApi = (id,p) => putJson(`/api/dict/v1/dicts/${id}`,p);//删除字典
export const dictAddlApi = p => post2(`/api/dict/v1/dicts`, p);//保存字典
export const dictListApi = p => get(`/api/dict/v1/dicts`, p);//字典 列表
export const dictOneApi = (id,p) => get(`/api/dict/v1/dicts/${id}`, p);//字典详情

//用户反馈相关接口
export const feedbackListApi = p => get(`/api/feedback/v1/feedbacks`, p);//用户反馈 列表
export const feedbackOneApi = (id,p) => get(`/api/feedback/v1/feedbacks/${id}`, p);//用户反馈详情
export const feedbackDelApi = (id,p) => del(`/api/feedback/v1/feedbacks/${id}`,p);//删除用户反馈
export const feedbackExportApi = p => getFileDown(`/api/feedback/v1/feedbacks/export`, p);//导出
//H5页面接口
export const feedBacksApi = p => post2(`/api/feedback/v1/feedbacks`,p) //提交表单
export const feedOfficeListApi = (type,p) => get(`/api/dict/v1/dicts/list/${type}`,p) //获取部门列表



